import { ServiceTerms } from "../types/interface";

const TERMS_CONTENT_URL = `https://pub-8b1a4c30cef04e9380c83f0d82243edf.r2.dev/data.json?v=${new Date().toISOString()}`;

// 使用者條款目前只支援中文、英文、日文
export type LanguageCode = "zh-TW" | "en-US" | "ja-JP";

// 非同步獲取條款內容
export const fetchTermsContent = async () => {
    try {
        const responseData: { data: Record<LanguageCode, ServiceTerms> } = await fetch(TERMS_CONTENT_URL, {
            method: "GET",
        }).then(async (res) => {
            if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
            return await res.json();
        });
        return responseData;
    } catch (error) {
        // eslint-disable-next-line no-console
        console.warn("Failed to fetch terms content from remote URL, using fallback:", error);
        // 發生錯誤時使用 fallback 內容
    }
};
